import { delay, http, HttpResponse } from 'msw';

const handlers = [
  http.get('*/v1/apps', async () => {
    await delay(200);
    return HttpResponse.json({
      baseUrl: 'https://static.sandbox.eu-01.eposnowhq.com/appsmenucdn/alpha',
      items: [
        [
          {
            projectId: 'backOffice',
            displayName: 'Back Office',
            iconKey: 'backoffice',
            url: 'https://www.alpha.sandbox.eu-01.eposnowhq.com/',
            openWithNativeHandler: null,
          },
          {
            projectId: 'organisations',
            displayName: 'Organisations',
            iconKey: 'organisations',
            url: 'https://organisations.alpha.sandbox.eu-01.eposnowhq.com/',
            openWithNativeHandler: null,
          },
          {
            projectId: 'account',
            displayName: 'Account',
            iconKey: 'account',
            url: 'https://account.alpha.sandbox.eu-01.eposnowhq.com',
            openWithNativeHandler: null,
          },
          {
            projectId: 'reporting',
            displayName: 'Reporting',
            iconKey: 'reporting',
            url: 'https://reporting.sandbox.eu-01.eposnowhq.com/',
            openWithNativeHandler: null,
          },
          {
            projectId: 'catalogue',
            displayName: 'Products',
            iconKey: 'products',
            url: 'https://products.alpha.sandbox.eu-01.eposnowhq.com/',
            openWithNativeHandler: null,
          },
          {
            projectId: 'capital',
            displayName: 'Capital',
            iconKey: 'capital',
            url: 'https://money.alpha.sandbox.eu-01.eposnowhq.com/capital',
            openWithNativeHandler: null,
          },
          {
            projectId: 'payments',
            displayName: 'Payments',
            iconKey: 'payments',
            url: 'https://money.alpha.sandbox.eu-01.eposnowhq.com/payments',
            openWithNativeHandler: null,
          },
          {
            projectId: 'till',
            displayName: 'Till',
            iconKey: 'till',
            url: 'https://www.alpha.sandbox.eu-01.eposnowhq.com/Pages/Till/DownloadApp.aspx',
            openWithNativeHandler: null,
          },
          {
            projectId: 'appStore',
            displayName: 'App Store',
            iconKey: 'appstore',
            url: 'https://appstore.eposnow.com/s/?language=en_US\u0026utm_medium=browser\u0026Hostname=https%3A%2F%2Faccount.eposnowhq.com\u0026utm_source=MyAccount',
            openWithNativeHandler: null,
          },
          {
            projectId: 'webStore',
            displayName: 'Web Store',
            iconKey: 'webstore',
            url: 'https://www.eposnow.com/uk/store/hardware/peripherals/',
            openWithNativeHandler: true,
          },
          {
            projectId: 'referrals',
            displayName: 'Referrals',
            iconKey: 'referrals',
            url: 'https://eposnow.referralrock.com/access/?programidentifier=05b01e66-3c76-45c8-9426-99d51bf440e2\u0026externalid=9c0f162f-2fc5-403a-a245-09a3f1956585\u0026lastname=ruiquaresma\u0026email=rui.emanuel.quaresma@eposnow.com',
            openWithNativeHandler: null,
          },
          {
            projectId: 'support',
            displayName: 'Support',
            iconKey: 'support',
            url: 'https://support.eposnow.com/',
            openWithNativeHandler: null,
          },
          {
            projectId: 'sidekick',
            displayName: 'Sidekick',
            iconKey: 'sidekick_v2',
            url: 'https://organisations.alpha.sandbox.eu-01.eposnowhq.com/sidekick',
            openWithNativeHandler: null,
          },
        ],
        [
          {
            projectId: 'admin',
            displayName: 'Epos Now Admin',
            iconKey: 'eposnowadmin',
            url: 'https://www.alpha.sandbox.eu-01.eposnowhq.com/Pages/Account/Mgmt/CompanyList.aspx',
            openWithNativeHandler: null,
          },
          {
            projectId: 'developer',
            displayName: 'Developer',
            iconKey: 'developer',
            url: 'https://www.alpha.sandbox.eu-01.eposnowhq.com/Apps/Developer/Index',
            openWithNativeHandler: null,
          },
        ],
      ],
    });
  }),
];

export default handlers;
